import { billOfMaterialsIdFormat } from "@redotech/redo-fulfillment-id";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const recordBomDisassembly = {
  name: "recordBomDisassembly" as const,
  input: z.object({
    bomId: billOfMaterialsIdFormat.schema,
    quantity: z.number().int().positive().max(100_000),
    locationId: locationIdFormat.schema,
  }),
  output: z.object({
    success: z.literal(true),
    outputsConsumed: z.number(),
    inputsRecovered: z.number(),
  }),
};
